
import { PROCEDURES_MANUAL_FETCH_ERROR,PROCEDURES_MANUAL_FETCH_SUCCESS, PROCEDURES_MANUAL_HIDE, PROCEDURES_MANUAL_SHOW,PROCEDURES_MANUAL_CREATE,PROCEDURES_MANUAL_CREATE_SUCCESS,PROCEDURES_MANUAL_CREATE_ERROR,PROCEDURES_MANUAL_FETCH } from '../reduxActions/Types';
import  _ from 'lodash';

const INITIAL_STATE = {
  projectId:null,
  functionId:null,
  procedures : [],
  displayProcedureManual:false,
  header:null,
  creatingProcedureManual:false,
  actionGroupForDisplayedProcedureManual:null,
  procedureManualShouldUpdate:false,
  fetchingProcedureManual:false
  
};

const checkIfProcedureManualHasUpdates = procedures => {

  const inProgressCount = _.filter(procedures,['status', 'In Progress']).length;
  const approvedCount = _.filter(procedures,['status', 'Approved']).length;

  const procedureManualShouldUpdate = (inProgressCount === 0 && approvedCount > 0);
  return procedureManualShouldUpdate;
}

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case PROCEDURES_MANUAL_FETCH : {
      return {
        ...state,
        procedures : [],
        fetchingProcedureManual:true

      }
    }
    case PROCEDURES_MANUAL_HIDE : {
      return {
        ...state,
        displayProcedureManual:false,
        procedures:[],
        header:null,
        actionGroupForDisplayedProcedureManual:null
      }
    }
    case PROCEDURES_MANUAL_SHOW : {
      return {
        ...state,
        displayProcedureManual:true,
        actionGroupForDisplayedProcedureManual:action.payload
      }
    }
    case PROCEDURES_MANUAL_FETCH_SUCCESS : {
      return {
        ...state,
        procedures:action.payload.procedures,
        procedureManualShouldUpdate:checkIfProcedureManualHasUpdates(action.payload.procedures),
        header:action.payload.header,
        fetchingProcedureManual:false
      } 
    }
    case PROCEDURES_MANUAL_FETCH_ERROR : {
      return {...state,fetchingProcedureManual:false}
    }
    case PROCEDURES_MANUAL_CREATE : {
      return {
        ...state,
        creatingProcedureManual:true
      }
    }
    case PROCEDURES_MANUAL_CREATE_ERROR : {
      return {
        ...state,
        creatingProcedureManual:false
      }
    }
    case PROCEDURES_MANUAL_CREATE_SUCCESS : {
      return {
        ...state,
        creatingProcedureManual:false,
        procedures:action.payload.procedures,
        procedureManualShouldUpdate:checkIfProcedureManualHasUpdates(action.payload.procedures),
        header:action.payload.header
      }
    }
    case 'RESET_ALL_REDUX_STATE':
      return INITIAL_STATE;
    default:
      return state;
  }
};
